import loadable from "@loadable/component"

import Introduction from "./Introduction"
import Form from "./Form"
import CustomerFeedback from "./CustomerFeedback"
import FormNavigator from "./FormNavigator"

// Lazy load these components for reduced package size on initial load
// these are either components that are unlikely to be on the front page OR components where a new version exists
const CallToAction = loadable(() => import("./CallToAction"))
const PhoneAction = loadable(() => import("./PhoneAction"))
const Paragraph = loadable(() => import("./Paragraph"))

export default {
  introduction: Introduction,
  callToAction: CallToAction,
  paragraph: Paragraph,
  phoneAction: PhoneAction,
  form: Form,
  customerFeedback: CustomerFeedback,
  formNavigator: FormNavigator,
}
